// WizardFooter — US-130 (cancel / save-draft CTAs).
//
// Extracted verbatim from CreateWizard's inline "Footer CTAs" block.

import { useT } from '@barel/i18n';
import { Button } from '@barel/ui';
import { Link } from '@tanstack/react-router';

export interface WizardFooterProps {
  onSubmit: () => void | Promise<void>;
  canCreate: boolean;
  isPending: boolean;
}

export function WizardFooter({ onSubmit, canCreate, isPending }: WizardFooterProps) {
  const t = useT('campaigns');
  return (
    <div className="flex justify-end gap-2">
      <Button asChild variant="ghost" size="md">
        <Link to="/campaigns" data-testid="wizard-cancel">
          {t('create.cancel')}
        </Link>
      </Button>
      <Button
        variant="primary"
        size="md"
        disabled={!canCreate || isPending}
        loading={isPending}
        onClick={() => void onSubmit()}
        data-testid="wizard-submit"
      >
        {t('create.submitDraft')}
      </Button>
    </div>
  );
}
